

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../controlador';
    import { Item } from '@/__env/lib/Ventas/Pedidos/Item';
    import { Factura } from '@/__env/lib/CuentasCorrientes/Facturas';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Controlador.Pedido.Cliente; }
        public get Envio() { return this.Controlador.Pedido.Envio; }

        public Cargando: boolean = false;
        public Facturas: Factura[] = [];

        async mounted()
        {
            this.Cargando = true;
            await Wait( 1000 );
            this.Facturas.clear();
            this.Facturas = await this.Pedido.CargarFacturas();
            this.Cargando = false;
        }

        public async Descargar( factura: Factura )
        {

            let pdf = await Factura.URLFactura( [factura] );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `No se encontró el PDF de la factura` );

            }
        }
    }
